import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SettingsWidgetContentRouter } from '../../../settings/types';
import { modules } from '../../modules';

@injectable()
export class SettingsWidgetContentRouterService implements SettingsWidgetContentRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${this.role.get()}/${modules.settings.basename}/${
          modules.widgets_content.basename
        }`,
      );
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.settings.basename}/${
        modules.widgets_content.basename
      }`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }
}
